var render = function render(_c,_vm){return _c('div',{class:{
    'd-flex flex-column align-end app-button-position-slot-button-margins':
      _vm.parent.$vuetify.breakpoint.smAndDown,
    'text-end': _vm.parent.$vuetify.breakpoint.mdAndUp
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }